import { setReloadWorklist } from "../../../../../../actions/manageVisitActions";

export const normalizeCareStepFormData = (formData) => ({
  ...formData,
  title: formData?.title?.replace(/\s+/g, " ").trim(),
});

export const saveCareStep = async ({
  action,
  step,
  formData,
  index,
  editExistingStep,
  saveNewStep,
  setFormData,
  dispatch,
  handleCancel,
}) => {
  try {
    if (action === "edit") {
      editExistingStep(step, normalizeCareStepFormData(formData), index);
    } else if (action === "delete") {
      const deletedStepFormData = {
        ...normalizeCareStepFormData(formData),
        deleted: true,
      };
      setFormData(deletedStepFormData);
      await saveNewStep(deletedStepFormData, index, action, step.stepNumber);
    } else {
      await saveNewStep(normalizeCareStepFormData(formData), index, action, step.stepNumber);
    }
    dispatch(setReloadWorklist(true));
    handleCancel();
    return true;
  } catch (error) {
    return false;
  }
};
